import { createApp } from 'vue'
import App from './App.vue'
import Vant from 'vant'
import router from './router'
import store from './store'
import 'vant/lib/index.css'
// import zhCN from '@/locales/zh-CN'
// import enUS from '@/locales/en-US'
// import { getUserLang } from '@/storage/user'
import i18n from '@/i18n'

const app = createApp(App)
app.use(Vant)
app.use(store)
app.use(router)
app.use(i18n)
// 关键：添加全局属性，确保模板中可以直接使用 $t
app.config.globalProperties.$t = i18n.global.t

// 在挂载应用之前，我们设置一个路由守卫来检查语言
router.beforeEach((to, from, next) => {
  // 检查路由中是否有lang参数
  const lang = to.query.lang as string
  if (lang) {
    if (lang === 'zh' || lang === 'en') {
      // 更新本地存储
      const locale = lang === 'zh' ? 'zh-CN' : 'en-US'
      localStorage.setItem('userLang', locale)
      // 更新i18n实例的语言
      i18n.global.locale = locale
    }
  }
  next()
})
app.mount('#app')
